import type { IField } from '@models/IFormData';

export function parseInspectorValue(draft: string, datatype?: string): IField['value'] {
    if (draft === '') return null;
    const base = datatype?.split('(')[0];
    if (base === 'integer') {
        const value = Number.parseInt(draft, 10);
        return Number.isNaN(value) ? null : value;
    }
    if (base === 'real' || base === 'money') {
        const value = Number.parseFloat(draft.replace(',', '.'));
        return Number.isNaN(value) ? null : value;
    }
    if (base === 'boolean') {
        if (draft === '1' || draft === 'true') return 1;
        if (draft === '0' || draft === 'false') return 0;
        return null;
    }
    if (!datatype) {
        if (draft === 'true') return true;
        if (draft === 'false') return false;
        if (!Number.isNaN(Number(draft)) && draft.trim() !== '') return Number(draft);
    }
    return draft;
}

export const directWriteKey = (...parts: Array<string | number>) => parts.join('::');

export const isExistingLinkedRow = (row: Record<string, unknown>): boolean => {
    const docId = row['|doc_Id'];
    if (typeof docId !== 'string' && typeof docId !== 'number') return false;
    const value = docId.toString();
    return value !== '' && value !== '-1';
};

export const toLinkedDocumentFieldName = (columnKey: string): string | null =>
    columnKey.startsWith('|LinkDocument|')
        ? columnKey.replace(/^\|LinkDocument\|/, '|Document|')
        : null;
